import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);

export function initEmployeeSlider() {
  const employeeSlider = document.querySelectorAll(
    ".mb-single-employee-slider"
  );

  let employeeSwiper = [];

  for (let i = 0; i < employeeSlider.length; i++) {
    employeeSwiper[i] = new Swiper(employeeSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}
